import { mutatorAction } from 'satcheljs';
import getListViewStore from 'owa-mail-list-store/lib/store/Store';
import { getCopilotResultsTableViewId, dismissCopilotResultsTabMutator } from 'owa-mail-list-store';
import TableOperations from 'owa-mail-list-table-operations';
import type TableView from 'owa-mail-list-store/lib/store/schema/TableView';

const removeTableViewMutator = mutatorAction(
    'removeCopilotResultsTableView',
    (tableViews: Map<string, TableView>, tableViewId: string) => {
        tableViews.delete(tableViewId);
    }
);

/**
 * Fully cleans up the CopilotResults table:
 * 1. Clears all rows from the table view
 * 2. Removes the table view from the store
 * 3. Clears the copilot results tab tracking state
 */
export default function cleanupCopilotResultsTable(): void {
    const copilotResultsTableViewId = getCopilotResultsTableViewId();
    if (!copilotResultsTableViewId) {
        return;
    }

    const store = getListViewStore();
    const tableView = store.tableViews.get(copilotResultsTableViewId);

    if (tableView) {
        TableOperations.clear(tableView);
        removeTableViewMutator(store.tableViews, copilotResultsTableViewId);
    }

    dismissCopilotResultsTabMutator();
}
